import React from 'react';
import robot from '../images/robot.png';

const PageHero=()=> {

  return (
    <div className="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg bg-white">
      <div className="col-lg-7 p-3 p-lg-5 pt-lg-3">
        <h1 className="display-4 fw-bold lh-1">Technology Radar</h1>
        <p className="lead">A few techniques, tools, platforms, languages & frameworks that are on my mind in 2022.</p>
      </div>
      <div className="col-lg-4 offset-lg-1 p-0 overflow-hidden">
          <img className="rounded-lg-3" src={robot} alt="" width="350" />
      </div>
    </div>
  )
}

export default PageHero;
